import {
  isSpreadsheetFormulaAuthoringAnalysis,
  type SpreadsheetFormulaAuthoringAnalysis,
} from '../protocol/spreadsheetEngineProtocol'
import { configureFormulaAuthoringParser } from './formulaAuthoring'

type FormulaAuthoringWasmBundle = {
  default?: () => Promise<unknown>
  parseFormulaAuthoringJson?: (input: string) => string
}

let parserReadyPromise: Promise<void> | null = null

const parseRustFormulaAuthoringJson = (
  parseFormulaAuthoringJson: (input: string) => string,
  text: string,
): SpreadsheetFormulaAuthoringAnalysis | null => {
  const parsed = JSON.parse(parseFormulaAuthoringJson(text)) as unknown
  if (!isSpreadsheetFormulaAuthoringAnalysis(parsed)) {
    throw new Error('Rust formula authoring parser returned malformed analysis')
  }
  return parsed
}

export const ensureFormulaAuthoringRustParser = async (): Promise<void> => {
  if (parserReadyPromise) return parserReadyPromise
  parserReadyPromise = (async () => {
    const bundle = await import('fusegrid_v2_wasm_nuclear' as string) as FormulaAuthoringWasmBundle
    if (typeof bundle.default === 'function') {
      await bundle.default()
    }
    if (typeof bundle.parseFormulaAuthoringJson !== 'function') {
      throw new Error('fusegrid_v2_wasm_nuclear is missing parseFormulaAuthoringJson; rebuild with npm run build:wasm')
    }
    configureFormulaAuthoringParser((text) => parseRustFormulaAuthoringJson(bundle.parseFormulaAuthoringJson!, text))
  })()
  return parserReadyPromise
}

